import { forwardRef, type Ref, type SVGProps } from "react";
const IconChecklistOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <rect width={6} height={2} x={17} y={10} rx={1} />
    <path d="M26 4v24H6V4zm0-2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2" />
    <path d="M14.73 7.78a.9.9 0 0 0-1.3 0l-2.21 2.36-.65-.69a.88.88 0 0 0-1.3 0 1 1 0 0 0 0 1.38l1.3 1.38a.87.87 0 0 0 1.3 0l2.86-3a1 1 0 0 0 0-1.43" />
    <path d="M14.73 14.78a.9.9 0 0 0-1.3 0l-2.21 2.36-.65-.69a.88.88 0 0 0-1.3 0 1 1 0 0 0 0 1.38l1.3 1.38a.87.87 0 0 0 1.3 0l2.86-3a1 1 0 0 0 0-1.43" />
    <rect width={6} height={2} x={17} y={17} rx={1} />
    <rect width={6} height={2} x={17} y={23} rx={1} />
    <rect width={4} height={2} x={10} y={23} rx={1} />
  </svg>
);
const ForwardRef = forwardRef(IconChecklistOutlineSVG);
ForwardRef.displayName = "IconChecklistOutline";
export { ForwardRef as IconChecklistOutline };
